import { gql } from '@apollo/client'

// TODO: as part of CVC-15308 we should move away from this call to the ones with clearer names
export const FETCH_REMINDER_PROTOCOLS_FOR_PROCEDURE = gql`
  query ReminderProtocolsForProcedure($priceId: ID!, $procedureId: ID!) {
    reminderProtocols(
      orderItemOptions: [
        { orderItemId: $priceId, orderItemType: PRICE, optionType: TRIGGER }
        {
          orderItemId: $procedureId
          orderItemType: PROCEDURE
          optionType: TRIGGER
        }
      ]
      includeDeleted: false
      limit: 2
      offset: 0
    ) {
      data {
        id
        businessId
        reminderName
        dueDateOffset {
          amount
          unit
        }
        orderItemOptions {
          orderItemId
          optionType
          orderItemType
        }
        deleted
      }
      totalCount
    }
  }
`
// Functionally the same as above, prefer this one for clarity
export const FETCH_REMINDER_PROTOCOLS_FOR_PROCEDURE_AND_PRICE = gql`
  query ReminderProtocolsForProcedureAndPrice(
    $priceId: ID!
    $procedureId: ID!
    $limit: PageLimit!
  ) {
    reminderProtocols(
      orderItemOptions: [
        { orderItemId: $priceId, orderItemType: PRICE, optionType: TRIGGER }
        {
          orderItemId: $procedureId
          orderItemType: PROCEDURE
          optionType: TRIGGER
        }
      ]
      includeDeleted: false
      limit: $limit
      offset: 0
    ) {
      data {
        id
        businessId
        reminderName
        dueDateOffset {
          amount
          unit
        }
        orderItemOptions {
          orderItemId
          optionType
          orderItemType
        }
        deleted
      }
      totalCount
    }
  }
`

export const FETCH_REMINDER_PROTOCOLS_FOR_PROCEDURE_ONLY = gql`
  query ReminderProtocolsForProcedureOnly(
    $procedureId: ID!
    $limit: PageLimit!
  ) {
    reminderProtocols(
      orderItemOptions: [
        {
          orderItemId: $procedureId
          orderItemType: PROCEDURE
          optionType: RESOLVE
        }
      ]
      includeDeleted: false
      limit: $limit
      offset: 0
    ) {
      data {
        id
        businessId
        reminderName
        dueDateOffset {
          amount
          unit
        }
        orderItemOptions {
          orderItemId
          optionType
          orderItemType
        }
        deleted
      }
      totalCount
    }
  }
`
